import { Skeleton } from '@mantine/core';
import { MainContainer } from './MainContainer';
import { PageHeader } from './PageHeader';

type Props = {
  children?: React.ReactNode;
  title?: string;
  description?: string;
};

export function PendingInitialize({ children, title, description }: Props) {
  return (
    <MainContainer>
      {title && <PageHeader title={title} description={description}></PageHeader>}
      {children ? children : <Skeleton visible w="100%" h="50vh" mt="xl" opacity="30%" />}
    </MainContainer>
  );
}
